export default {
  loading: false,
  orderList: [],
  serviceList: [],
  selectedServiceID: null,
};
